// extracted by mini-css-extract-plugin
export default {"page":"dLv9k","loading":"_vqJC","header":"W2xqy","button":"YPzmc","inner":"IXiLK","actionCell":"hm6gO","editIcon":"s6jHN","emptyText":"rU4cl"};